<button matRipple (click)="share()" class="button" [title]="'general.share'| translate" >
     {{ 'page.detail.buttons.title_share' | translate }}
</button>
